import {createEventBus} from '@malt/vue-event-bus/create-event-bus';

export type Events = {
    'funnel:previous:click': undefined;
    'funnel:next:click': undefined;
};

export const eventBus = createEventBus<Events>();
